module.exports = __webpack_public_path__ + "img/app-store-badge-2@2x.fc52bcbd.png";